import './App.css';
import Desktop from './components/os/Desktop';
import { Analytics } from "@vercel/analytics/react"

function App() {
    return (
        <div className="App">
            <Desktop />
        </div>
    );
}

export default App;
